export default "__VITE_ASSET__BUSfy_hm__"